<template>
  <div class="title">
    <div class="logo">
      <img src="@/assets/title-logo.png" class="title-logo" @click="goHome()">
    </div>
    <div class="title-box" :style="{color: fontColor}">
      <div @click="onFirestorm(0)" :class="(menuIndex===0)?'title-index':''">简介</div>
      <div @click="onFirestorm(1)" :class="(menuIndex===1)?'title-index':''">产品与团队</div>
      <div @click="onFirestorm(2)" :class="(menuIndex===2)?'title-index':''">加入我们</div>
      <div @click="onFirestorm(3)" :class="(menuIndex===3)?'title-index':''">联系我们</div>
      <!-- <div @click="onFirestorm(4)" :class="(menuIndex===4)?'title-index':''">CN</div> -->
    </div>
    <div class="navigation" @click="showMenu">
      <img src="@/assets/navigation.png" v-if="getNavigation()">
      <img src="@/assets/navigation-w.png" v-else>
    </div>
    <div class="menu-box" v-if="menu">
      <div @click="onFirestorm(0)" :class="(menuIndex===0)?'title-index':''">简介</div>
      <div @click="onFirestorm(1)" :class="(menuIndex===1)?'title-index':''">产品与团队</div>
      <div @click="onFirestorm(2)" :class="(menuIndex===2)?'title-index':''">加入我们</div>
      <div @click="onFirestorm(3)" :class="(menuIndex===3)?'title-index':''">联系我们</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    menuIndex: {
      type: Number,
      default: 0
    },
    fontColor: {
      type: String,
      default: '#ffffff'
    }
  },
  name: "Home",
  data () {
    return {
      index: 0,
      menu: false
    }
  },
  mounted () {

  },
  methods: {
    onFirestorm (value) {
      switch (value) {
        case 0:
          this.$router.push({ path: '/' })
          break;
        case 1:
          this.$router.push({ path: '/team' })
          break;
        case 2:
          this.$router.push({ path: '/welfare' })
          break;
        case 3:
          this.$router.push({ path: '/about' })
          break;
        default:
          break;
      }
      this.$nextTick(() => {
        window.scrollTo(0, 0);
      })
    },
    goHome () {
      this.$router.push({ path: '/' })
    },
    showMenu () {
      this.menu = !this.menu
    },
    getNavigation () {
      if (this.menu) {
        return true
      }
      if (this.menuIndex === 2 || this.menuIndex === 1) {
        return true
      }
    }
  }
};
</script>

<style lang="less" scoped>
@minwidth: 768px;
.title {
  position: absolute;
  width: 100%;
  left: 0px;
  top: 0px;
  z-index: 100;
  .title-logo {
    height: 50px;
    cursor: pointer;
    @media screen and (max-width: @minwidth) {
      height: 130px;
    }
  }
  .logo {
    position: absolute;
    left: 270px;
    top: 0px;
    height: 80px;
    display: flex;
    align-items: center;
    @media screen and (max-width: @minwidth) {
      left: 20px;
      top: 20px;
      height: 180px;
    }
  }
  .title-box {
    // width: 100%;
    padding: 0px 650px;
    display: flex;
    justify-content: space-between;
    font-size: 18px;
    color: #ffffff;
    text-align: left;
    line-height: 100px;
    div {
      cursor: pointer;
    }
    @media screen and (max-width: @minwidth) {
      display: none;
    }
  }
  .title-index {
    color: #ffa317;
  }
  .navigation {
    position: absolute;
    right: 20px;
    top: 80px;
    @media screen and (min-width: @minwidth) {
      display: none;
    }
    img {
      width: 100px;
    }
  }
  .menu-box {
    background-color: #ffffff;
    padding: 200px 0px 0px 0px;
    div {
      text-align: center;
      padding: 50px 0px;
    }
  }
}
</style>
